import { createContext, useContext } from "react";

import { EventOffer } from "@gp/offer";
import { getOfferHistoryScore } from "@utils/offer/offerHistoryScore";

export interface OfferHistoryColumns {
	hasResult: boolean;
}

export const OfferHistoryColumnsContext =
	createContext<OfferHistoryColumns | null>(null);

export function useOfferHistoryColumns(): OfferHistoryColumns {
	const columns = useContext(OfferHistoryColumnsContext);

	return columns ?? { hasResult: true };
}

export function getOfferHistoryColumns(
	events: EventOffer[] | undefined
): OfferHistoryColumns {
	const columns: OfferHistoryColumns = {
		hasResult: false,
	};

	for (const event of events ?? []) {
		const score = getOfferHistoryScore(event.result);

		if (score.fullTime != null || score.overTime != null) {
			columns.hasResult = true;
			break;
		}
	}

	return columns;
}
